import { ReactComponent as Rocket } from '../assets/images/rocket.svg';

export const Boost = () => (
  <div className="boost">
    <div className="boost-clouds"></div>
    <div className="boost-rocket">
      <Rocket />
      <div className="boost-rocket-fire">
        <svg
          className="boost-rocket-fire-first"
          width="54"
          height="20"
          viewBox="0 0 54 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0.96344 9.90482C0.96344 9.90482 21.5886 -2.28146 53.3325 1.71586V18.9543C53.3325 18.9543 24.5958 23.8307 0.96344 9.90482Z"
            fill="url(#paint0_linear_1_4606)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_1_4606"
              x1="0.96344"
              y1="10.3582"
              x2="53.8073"
              y2="10.3582"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#F5EA91" />
              <stop offset="1" stopColor="#DA9231" />
            </linearGradient>
          </defs>
        </svg>
        <svg
          className="boost-rocket-fire-second"
          width="73"
          height="29"
          viewBox="0 0 73 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0.327698 13.7014C0.327698 13.7014 28.6885 -4.8047 72.3327 1.28381V27.4515C72.3327 27.4515 32.8135 34.7891 0.327698 13.7014Z"
            fill="url(#paint0_linear_1_4605)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_1_4605"
              x1="0.327698"
              y1="14.3584"
              x2="72.9856"
              y2="14.3584"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#F5E55E" />
              <stop offset="1" stopColor="#DA9231" />
            </linearGradient>
          </defs>
        </svg>
        <svg
          className="boost-rocket-fire-thirty"
          width="116"
          height="61"
          viewBox="0 0 116 61"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M115.333 17.2468C93.4314 14.3414 71.1345 -15.7496 26.5308 11.3804C37.4517 8.41942 51.5876 7.17025 62.3206 13.9712C55.9896 13.6937 37.4022 9.34472 0 30.3492C37.4022 51.3813 55.9896 47.0047 62.3206 46.7456C51.5876 53.5281 37.4517 52.2974 26.5308 49.3272C71.1345 76.4571 93.4314 46.3569 115.333 43.4515V17.2468Z"
            fill="url(#paint0_linear_1_4604)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_1_4604"
              x1="0"
              y1="30.3492"
              x2="116.381"
              y2="30.3492"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#FEE62A" />
              <stop offset="0.14" stopColor="#FDD82B" />
              <stop offset="0.4" stopColor="#F9B42C" />
              <stop offset="0.75" stopColor="#F37B2F" />
              <stop offset="0.99" stopColor="#EF4E31" />
            </linearGradient>
          </defs>
        </svg>
      </div>
    </div>
  </div>
);
